import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 44 44"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "44",
      height: "44",
      fill: "#f8f8f8",
      rx: "12"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#59ad3b",
      d: "M28.717 14.764H15.283a2.68 2.68 0 0 0-1.967.816 2.68 2.68 0 0 0-.816 1.967v8.906c0 .767.272 1.423.816 1.967a2.68 2.68 0 0 0 1.967.816h13.434a2.68 2.68 0 0 0 1.967-.816 2.68 2.68 0 0 0 .816-1.967v-8.906a2.68 2.68 0 0 0-.816-1.967 2.68 2.68 0 0 0-1.967-.816Zm-9.5 11.077v-7.57L25.915 22l-6.698 3.84Zm1.113-5.678v3.748L23.651 22l-3.32-1.837Z"
    }, null, -1)
  ])))
}
export default { render: render }